/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-11",
    versionChannel: "nightly",
    buildDate: "2023-07-11T00:23:24.795Z",
    commitHash: "db252dabc3b82542946dfd6766d6c92bc9a88ad3",
};
